import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { Translation } from '@morningtrain/react-translations'
import useFormattedDate from 'support/hooks/formatters/useFormattedDate'

export default function InventoryOrderStatus () {
  const status = useValue('status')

  const orderedAtValue = useValue('ordered_at')
  const orderedAt = useFormattedDate(orderedAtValue)

  const deliveryAtValue = useValue('order_for_start')
  const deliveryAt = useFormattedDate(deliveryAtValue)

  const receivedAtValue = useValue('received_at')
  const receivedAt = useFormattedDate(receivedAtValue)

  const receivedPrice = useValue('received_price')
  const totalPrice = useValue('total_price')
  const offsetPrice = (receivedPrice - totalPrice).toFixed(2)

  const weekdaysCount = useValue('weekdays_count')

  const transData = {
    deliveryAt: deliveryAt,
    orderedAt: orderedAt,
    receivedAt: receivedAt,
    daysCount: weekdaysCount,
    receivedPrice: receivedPrice,
    totalPrice: totalPrice,
    offsetPrice: offsetPrice
  }

  let description = null

  if (status === 'pending') {
    description = (
      <Translation name='description.pending' data={transData} />
    )
  }

  if (status === 'completed') {
    description = (
      <Translation name='description.completed' data={transData} />
    )
  }

  if (status === 'received') {
    description = (
      <Translation name='description.received' data={transData} />
    )
  }

  if (status === 'draft') {
    description = (
      <Translation name='description.draft' data={transData} />
    )
  }

  return (
    <div className='max-w-xs'>
      {description}
    </div>
  )
}
